import { RequestData } from 'js/helpers/service';
import { generateRuid } from 'js/helpers/ruid';
import { BrowsePageOutput } from 'js/model/rainbow/browse-page/BrowsePageOutput';
import { VenueListingCriteria } from 'js/model/rainbow/browse-page/VenueListingCriteria';
import { stringify } from 'qs';
import { VenueMenuItemType } from 'js/model/rainbow/VenueMenuItemType';
import { RequestHeaders, httpGetJson } from 'js/common/http';
import { isServer } from 'js/helpers/environment';
import { GrowthBook } from '@growthbook/growthbook';
import { MP_API_BASE_URL } from 'server/constants';

export const isBrowseApiV2Enabled = (gb?: GrowthBook) =>
  gb?.isOn('ff-web-browse__v2-browse-api') ?? false;

export const getBrowseApiBaseUrl = (isV2Enabled = false) =>
  isServer && isV2Enabled ? MP_API_BASE_URL : '';

export const composeFetchBrowse = (
  baseUrl = '',
  isBrowseApiV2Enabled = false
) => {
  const apiVersion = isBrowseApiV2Enabled ? 'v2' : 'v1';

  return async (
    state: RequestData,
    browsePath: string,
    ruid: string = generateRuid(),
    parameters: VenueListingCriteria = {}
  ) => {
    const parametersWithUri = {
      ...parameters,
      currentBrowseUri: decodeURIComponent(browsePath),
    };

    let requestHeaders: RequestHeaders = {};

    if (isServer) {
      if (isBrowseApiV2Enabled) {
        requestHeaders['x-forwarded-host'] =
          state.requestHeaders['x-forwarded-host'];
        requestHeaders['x-language-code'] =
          state.requestHeaders['x-language-code'];
      } else {
        requestHeaders = state.requestHeaders;
      }
    }

    const browsePageOutput = await httpGetJson<BrowsePageOutput>(
      `${baseUrl}/api/${apiVersion}/page/browse?${stringify(parametersWithUri, {
        allowDots: true,
        arrayFormat: 'comma',
      })}`,
      {
        requestHeaders,
        ruid,
      }
    );

    if (!browsePageOutput) {
      throw new Error('Error occurred fetching Browse data');
    }

    // Remove service option groups. They're not currently used by browse page,
    // and would add significantly to the state that is marshalled and sent to
    // the browser.
    browsePageOutput.results.forEach((result) => {
      result.data.menuHighlights.forEach((service) => {
        if (
          service.type === VenueMenuItemType.Treatment ||
          service.type === VenueMenuItemType.TreatmentPackage
        ) {
          // eslint-disable-next-line no-param-reassign
          service.data.optionGroups = [];
        }
      });
    });

    return browsePageOutput;
  };
};
